module.exports = __webpack_public_path__ + "media/notEnoughCoin3.6a73d2b2.mp3";